import {ActionButtonRow, EntityTable, HeadlineH1, LoadingIndicator} from 'arkulpa-fec';
import gql from 'graphql-tag';
import {FlatButton} from 'material-ui';
import PropTypes from 'prop-types';
import React, {Fragment} from 'react';
import {Query} from 'react-apollo';
import ReactJson from 'react-json-view';
import {withRouter} from 'react-router';
import moment from 'moment';
import styled from 'styled-components';
import {translateDryState} from './DeviceDetail';

const boolOutput = value => (value ? 'true' : 'false');

const StateDiv = styled.div`
  color: white;
  font-weight: bold;
  background: cornflowerblue;
  padding: 5px;
`;
const AlertDiv = styled.div`
  color: white;
  font-weight: bold;
  background: coral;
  padding: 5px;
`;
const LogDiv = styled.div`
  color: white;
  font-weight: bold;
  background: lightblue;
  padding: 5px;
`;

const renderJson = ({type, json}) => {
  return (
    <Fragment>
      {type === 'state' && renderStateDetails(json)}
      {type === 'alert' && renderAlertDetails(json)}
      <ReactJson src={json} {...JSON_VIEW_OPTIONS} />
    </Fragment>
  );
};
const renderStateDetails = ({wet, occupied, connected}) => {
  return (
    <div>
      wet: <b>{translateDryState(wet)}</b>, occupied: <b>{boolOutput(occupied)}</b>, connected:{' '}
      <b> {boolOutput(connected)}</b>
    </div>
  );
};

const renderAlertDetails = ({type, sendDates, ack, ackByUser, disabledOnDevice, snoozed, testAlarm}) => {
  return (
    <div>
      Type: <b>{type}</b>, push sent: <b>{sendDates.length} times</b>, ack: <b>{boolOutput(ack)}</b>, ack by user:{' '}
      <b>{boolOutput(ack && ackByUser)}</b>, push disabled: <b>{boolOutput(disabledOnDevice)}</b>, snoozed:{' '}
      <b>{boolOutput(snoozed)}</b>, Test alarm: <b>{boolOutput(testAlarm)}</b>
    </div>
  );
};

const renderType = type => {
  return type === 'state' ? (
    <StateDiv>{type}</StateDiv>
  ) : type === 'log' ? (
    <LogDiv>{type}</LogDiv>
  ) : (
    <AlertDiv>{type}</AlertDiv>
  );
};

const _tableConfig = maxRows => {
  return {
    maxRows,
    cols: [
      {
        header: 'Type',
        valueKey: 'type',
        method: type => renderType(type),
        width: '15%',
      },
      {
        header: 'Timestamp',
        valueKey: 'timestamp',
        method: timestamp => moment(timestamp).format('DD.MM.YYYY, h:mm:ss'),
        width: '15%',
      },
      {
        header: 'Payload',
        valueKey: '*',
        method: log => renderJson(log),

        width: '70%',
      },
    ],
  };
};

const JSON_VIEW_OPTIONS = {
  name: 'payload',
  collapsed: true,
  indentWitdh: 2,
};

const GET_DEVICE_LOGS = gql`
  query getDeviceLogs($input: DeviceLogInput!) {
    getDeviceLogs(input: $input) {
      type
      timestamp
      json
    }
  }
`;

const DeviceDebug = ({
  match: {
    params: {id, deviceId},
  },
  history,
}) => {
  return (
    <Query query={GET_DEVICE_LOGS} variables={{input: {_id: id, deviceId, stateLimit: 100}}}>
      {({loading, error, data: {getDeviceLogs}, refetch}) => {
        if (loading) return <LoadingIndicator />;
        if (error) return `Error! ${error.message}`;

        return (
          <div>
            <HeadlineH1>Device Debug {deviceId}</HeadlineH1>

            <EntityTable
              tableConfig={_tableConfig(1000)}
              data={loading ? [] : getDeviceLogs}
              msg={'No log informations available'}
            />

            <ActionButtonRow>
              <FlatButton onClick={() => history.push(`/device/${id}`)} label='Back to detail' />
            </ActionButtonRow>
          </div>
        );
      }}
    </Query>
  );
};
DeviceDebug.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(DeviceDebug);



// WEBPACK FOOTER //
// ./src/components/DeviceDebug.js